import React, { Component } from "react";
import SharedHelmet from ".././Helmet";
import ramadanImg from "../../../images/ramadan.webp";
import eidAdhaImg from "../../../images/eid-adha.webp";
import eidFatrImg from "../../../images/eid-fatr.webp";
import motherImg from "../../../images/mother.webp";
import schoolImg from "../../../images/back-to-school.webp";
import footballImg from "../../../images/football.webp";
import summerImg from "../../../images/summer.webp";
class Articles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "Umum",
      links: {
        technology: [],
        health: [],
        women: [],
        Umum: [
          {
            id: 1,
            title: "Berapa hari lagi Ramadan 2026",
            url: "/articles-id/ramadan/",
            imageUrl: ramadanImg,
            description: "Temukan jadwal Ramadan 2026 sekarang",
          },
          {
            id: 2,
            title: "Berapa hari lagi Idul Adha 2026",
            url: "/articles-id/eid-adha/",
            imageUrl: eidAdhaImg,
            description: "Temukan jadwal Idul Adha 2026 sekarang",
          },
          {
            id: 3,
            title: "Berapa hari lagi Idul Fitri 2026",
            url: "/articles-id/eid-fatr/",
            imageUrl: eidFatrImg,
            description: "Temukan jadwal Idul Fitri 2026 sekarang",
          },
          {
            id: 4,
            title: "Berapa hari lagi Malam Nisfu Syaban 2026",
            url: "/articles-id/shaban/",
            imageUrl: eidFatrImg,
            description: "Temukan jadwal Malam Nisfu Syaban 2026 sekarang",
          },
          {
            id: 5,
            title: "Berapa hari lagi Tahun Baru Hijriah 2026",
            url: "/articles-id/hijri/",
            imageUrl: eidFatrImg,
            description: "Temukan jadwal Tahun Baru Hijriah 2026 sekarang",
          },
          {
            id: 6,
            title: "Berapa hari lagi Hari Ibu 2026",
            url: "/articles-id/motherday/",
            imageUrl: motherImg,
            description: "Temukan jadwal Hari Ibu 2026 sekarang",
          },
          {
            id: 7,
            title: "Berapa hari lagi Tahun Ajaran Baru di Arab Saudi 2026",
            url: "/articles-id/schooldaySA/",
            imageUrl: schoolImg,
            description: "Temukan jadwal Tahun Ajaran Baru di Arab Saudi 2026 sekarang",
          },
          {
            id: 8,
            title: "Berapa hari lagi Piala Dunia 2026",
            url: "/articles-id/worldcup/",
            imageUrl: footballImg,
            description: "Temukan jadwal Piala Dunia 2026 sekarang",
          },
          {
            id: 8,
            title: "Berapa hari lagi Olimpiade 2028",
            url: "/articles-id/olympics/",
            imageUrl: footballImg,
            description: "Temukan jadwal Olimpiade 2028 sekarang",
          },
          {
            id: 8,
            title: "Berapa hari lagi Piala Asia 2027",
            url: "/articles-id/asian-cup/",
            imageUrl: footballImg,
            description: "Temukan jadwal Piala Asia 2027 sekarang",
          },
          {
            id: 9,
            title: "Berapa hari lagi Musim Panas 2026",
            url: "/articles-id/summer/",
            imageUrl: summerImg,
            description: "Temukan jadwal Musim Panas 2026 sekarang",
          },
        ],
      },
    };
  }

  handleTabClick = (tabName) => {
    this.setState({ activeTab: tabName });
  };

  render() {
    const TITLE = "Artikel Kesehatan, Olahraga, dan Umum";
    const DESCRIPTION =
      "Jelajahi dunia teknologi, kesehatan, keuangan, pemberdayaan perempuan, tips kecantikan, dan wawasan Islam. Tetap terinformasi, sehat, dan sadar secara finansial mengenai gaya hidup dan spiritualitas Anda";
    const KEYWORDS =
      "jelajahi dunia teknologi, kesehatan, keuangan, pemberdayaan perempuan, tips kecantikan, artikel Islam";
    const OG_URL = "https://do-calculate.com/articles-id/";
    const { activeTab, links } = this.state;
    const activeTabLinks = links[activeTab];
    const tabContainerStyle = {
      display: "flex",
      borderBottom: "1px solid #dee2e6",
    };
    const tabButtonStyle = {
      flex: 1,
      padding: "10px 15px",
      cursor: "pointer",
      border: "none",
      background: "#f8f9fa",
      color: "#495057",
      textAlign: "center",
      fontWeight: "500",
      borderRadius: "0.25rem",
      margin: "0",
      borderBottom: "2px solid transparent",
    };
    const tabButtonActiveStyle = {
      ...tabButtonStyle,
      background: "#ffffff",
      color: "#007bff",
      borderBottom: "2px solid #007bff",
    };
    const tabContentStyle = {
      padding: "15px",
      borderTop: "1px solid #dee2e6",
    };
    const tabLabels = {
      technology: "Teknologi",
      health: "Kesehatan",
      women: "Perempuan",
      Umum: "Umum",
    };
    const availableTabs = Object.keys(links)
      .filter((tab) => links[tab] && links[tab].some((article) => article.id))
      .map((tabName) => tabName);
    return (
      <div className="ltr">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div className="bg-success text-white" role="alert" style={{ height: "50px", alignItems: "center", display: "flex", justifyContent: "center" }}>
          {DESCRIPTION}.
          <div className="text-center">
          </div>
        </div>
        <hr />
        <section id="tabs">
          <div style={tabContainerStyle}>
            {availableTabs.map((tabName) => (
              <button
                key={tabName}
                style={
                  activeTab === tabName ? tabButtonActiveStyle : tabButtonStyle
                }
                onClick={() => this.handleTabClick(tabName)}
              >
                {tabLabels[tabName] || tabName.charAt(0).toUpperCase() + tabName.slice(1)}
              </button>
            ))}
          </div>
        </section>
        {activeTabLinks && activeTabLinks.length > 0 && (
          <section id="gallery" style={tabContentStyle}>
            <div className="container">
              <div className="row">
                {activeTabLinks.map(
                  (link) =>
                    link.id && (
                      <div
                        key={link.id}
                        className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                      >
                        <div className="card">
                          <img
                            src={link.imageUrl}
                            alt={link.title}
                            className="card-img-top"
                            style={{ width: "100%", height: "200px" }}
                          />
                          <div className="card-body">
                            <h5 className="card-title">{link.title}</h5>
                            <p className="card-text">{link.description}</p>
                            <a
                              href={link.url}
                              className="btn btn-outline-success btn-sm"
                            >
                              Baca Selengkapnya
                            </a>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}
export default Articles;
